/**
 * @packageDocumentation
 * @module Object
 */
import { normalisePath } from '../normalisePath';
import { getFromBaseFunction } from './getFromBaseFunction';
/**
 * From a given object get the value defined at a given path, denoted by dot notation or an array. This function serves as a wrapper function for the getFromBaseFunction. The purpose of it is to provide with high-level formatting.
 *
 * @param {any} values
 * @param {string | string[]} path
 *
 * @return {any}
 */
export var getFrom = function (values, path) { return getFromBaseFunction(values, normalisePath(path)); };
//# sourceMappingURL=getFrom.js.map